import { BehaviorSubject } from 'rxjs';
import type { CustomProps, ParcelConfig } from 'single-spa';
import { mountRootParcel } from 'single-spa';

/** Instancia parcel devuelta por `mountParcel` / `mountRootParcel`. */
export type MountedSingleSpaParcel = ReturnType<typeof mountRootParcel>;

export interface MicrofrontendProps {
  usuario: string;
  rol: string;
  token: string;
  whitelabel: string;
  /** Valor alineado con DominioOrigen (1|2|3), hostname o texto con agilice/redmat/iconstruye. */
  Dominio?: string | number;
  /** Código de país (p. ej. CO) enviado al host en `DesplegarMenuComprador?idPais=`. */
  IdPais?: string;
  onLogout: () => void;
}

export interface SingleSpaProps {
  IdEmpresa?: number;
  IdUsuario?: string;
  IdOrg?: number;
  name?: string;
  mountParcel?: (
    parcelConfig: ParcelConfig,
    customProps: CustomProps & { domElement: HTMLElement }
  ) => MountedSingleSpaParcel;
  singleSpa?: any;
  Redirect?: any;
  Fallback?: any;
  CargaMenu?: any;
  UrlSitio?: string;
  // Props específicas del microfrontend
  usuario?: string;
  rol?: string;
  token?: string;
  whitelabel?: string;
  /** Origen de marca desde el host single-spa; determina el tema si está presente. */
  Dominio?: string | number;
  /** País desde el shell (p. ej. CO); se envía como query `idPais` al desplegar menú. */
  IdPais?: string;
  /** Contexto opcional para MF banner-transversal. */
  apiUrl?: string;
  productId?: string;
  userId?: string;
  companyId?: string;
  userEmail?: string;
  userName?: string;
  companyName?: string;
  /** IDs de banners para el MF banner-transversal (Convenios, etc.). */
  BannerIds?: string | string[];
  /** Contador interno del shell; fuerza reenvío al banner en cada clic de menú. */
  SecuenciaNavegacionMenu?: number;
  onLogout?: () => void;
  [key: string]: any;

  redirectToBanner?: (url: string, isRedirect: boolean) => void;

  
}

export const singleSpaPropsSubject = new BehaviorSubject<SingleSpaProps>({});

